/* eslint-disable no-undef */
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "swiper/css";
import "swiper/css/navigation";
import swal from 'sweetalert2';
import { createApp } from 'vue';

require("./bootstrap");
require("./headings");
require('./defer-youtube');
require('./chatbutton');
require('./card-carousel');
require('./accordion');

import AccountCreationForm from "./components/AccountCreationForm.vue";
import CreateAccountActivated from "./components/CreateAccountActivated.vue";
import ProgressBar from "./components/ProgressBar.vue";
import InputRadioGroup from "./components/Form/InputRadioGroup.vue";
import ApplicationForm from "./components/ApplicationForm.vue";
import ApplicationFormGetInto from "./components/ApplicationFormGetInto.vue";
import StepsBlock from "./components/StepsBlock.vue";
import ForgotPassword from "./components/ForgotPassword.vue";
import ResetPassword from "./components/ResetPassword.vue";
import InstantSearch from 'vue-instantsearch/vue3/es';
import RegistrationForm from "./components/Programmes/GetInto/Registration/RegistrationForm.vue";
import BookingConfirmationRegisteredUser from "./components/Programmes/GetInto/BookingConfirmationRegisteredUser.vue";
import ProfileForm from "./components/ProfileForm.vue";
import DocumentUpload from "./components/DocumentUpload.vue";
import AlgoliaSearch from "./components/AlgoliaSearch";
import CreateAccountForm from "./components/CreateAccountForm.vue";
import CreateAccountConfirm from "./components/CreateAccountConfirm.vue";
import CreateAccountError from "./components/CreateAccountError.vue";
import CreateAccountSafeguarding from "./components/CreateAccountSafeguarding.vue";

const app = createApp({
    components: {
        ForgotPassword,
        ResetPassword,
        AccountCreationForm,
        ProgressBar,
        ApplicationForm,
        ApplicationFormGetInto,
        StepsBlock,
        RegistrationForm,
        ProfileForm,
        DocumentUpload,
        BookingConfirmationRegisteredUser,
        AlgoliaSearch,
        InputRadioGroup,
        CreateAccountForm,
        CreateAccountConfirm,
        CreateAccountActivated,
        CreateAccountError,
        CreateAccountSafeguarding,
    },
});

window.Swal = swal;

app.use(InstantSearch);

app.mount('#app');
